const generateAdmitcardActions = {
    GENERATE_ADMIT_CARD: 'GENERATE_ADMIT_CARD',
    DELETE_ADMIT_CARD: 'DELETE_ADMIT_CARD',
    INSERT_EXTERNAL_COURSE:'INSERT_EXTERNAL_COURSE',
    GET_EXTERNAL_COURSE:'GET_EXTERNAL_COURSE',
    SET_EXTERNAL_COURSE:'SET_EXTERNAL_COURSE',
   GENERATE_EXTERNAL_ADMITCARD:'GENERATE_EXTERNAL_ADMITCARD',
   ADD_EXTERNAL_COURSE:'ADD_EXTERNAL_COURSE',
   GENERATE_BULK_ADMITCARD:'GENERATE_BULK_ADMITCARD',
   GET_BULK_ADMITCARD_COUNT:'GET_BULK_ADMITCARD_COUNT',
   SET_BULK_ADMITCARD_COUNT:'SET_BULK_ADMITCARD_COUNT',
   GET_EXTERNAL_ZIPFILE:'GET_EXTERNAL_ZIPFILE',
   GET_INTERNAL_ZIPFILE:'GET_INTERNAL_ZIPFILE',
   GET_ADMITCARD_URL:'GET_ADMITCARD_URL'
};

export default generateAdmitcardActions;